import { Icon } from '@iconify/react';
import PopoverInfo from '../common/PopoverInfo';

/**
 * Configuración centralizada de estatus
 */
const STATUS_CONFIG = {
  success: {
    color: 'bg-green-100 text-green-700 border border-green-300',
    icon: 'mdi:check-circle-outline',
    label: 'OK.',
  },
  ini: {
    color: 'bg-gray-100 text-gray-700 border border-gray-300',
    icon: 'mdi:clock-outline',
    label: 'PTE.',
  },
  error: {
    color: 'bg-red-100 text-red-700 border border-red-300',
    icon: 'mdi:alert-circle-outline',
    label: 'Error',
    isError: true,
  },
  sinarchivo: {
    color: 'bg-orange-100 text-orange-700 border border-orange-300',
    icon: 'mdi:alert-circle-outline',
    label: 'ND',
  },
  vacio: {
    color: 'bg-purple-100 text-purple-700 border border-purple-300',
    icon: 'mdi:alert-circle-outline',
    label: 'Vacío',
  },
  na: {
    color: 'bg-yellow-100 text-yellow-700 border border-yellow-300',
    icon: 'mdi:help-circle-outline',
    label: 'N/A',
  },
};

const ErrorPopover = ({ status, errorMessage }) => {
  const rawStatus = status?.toLowerCase() || 'na';
  const normalizedStatus = rawStatus === 'er' ? 'error' : rawStatus;

  const config =
    STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.na;

  const content = (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium cursor-pointer ${config.color}`}
    >
      <Icon icon={config.icon} className="w-4 h-4 inline-block mr-1" />
      <span>{config.label}</span>
    </span>
  );

  /**
   * Popover solo para error
   */
  if (config.isError) {
    let errorMsg = errorMessage;

    if (typeof errorMsg === 'string' && /%[0-9A-Fa-f]{2}/.test(errorMsg)) {
      try {
        const decoded = decodeURIComponent(errorMsg);
        try {
          errorMsg = JSON.parse(decoded);
        } catch {
          errorMsg = decoded;
        }
      } catch {
        errorMsg = errorMessage;
      }
    } else {
      try {
        errorMsg = JSON.parse(errorMsg);
      } catch {
        // no-op
      }
    }

    const info = (
      <div className="p-2 text-sm text-gray-700 space-y-1">
        <p><strong>Estatus:</strong> {config.label}</p>
        <p><strong>Error:</strong></p>
        <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
          {typeof errorMsg === 'object'
            ? JSON.stringify(errorMsg, null, 2)
            : errorMsg}
        </pre>
      </div>
    );

    return (
      <PopoverInfo trigger={content}>
        {info}
      </PopoverInfo>
    );
  }

  return content;
};

export default ErrorPopover;
